const DEFAULT_CONFIG = {
  accountID: process.env.NEW_RELIC_WIDGET_ACCOUNT_ID,
  licenseKey: process.env.NEW_RELIC_WIDGET_LICENSE_KEY,
  applicationID: process.env.NEW_RELIC_WIDGET_APPLICATION_ID,
  trustKey: process.env.NEW_RELIC_WIDGET_TRUST_KEY,
  allowedDomains: process.env.NEW_RELIC_WIDGET_ALLOWED_DOMAINS
    ? process.env.NEW_RELIC_WIDGET_ALLOWED_DOMAINS.split(",").map((d) => d.trim()).filter(Boolean)
    : [],
};

export function initNewRelic(config = {}) {
  if (window.__NR_LOADER_INITIALIZED__) {
    console.log("New Relic Browser Agent already initialized");
    return;
  }

  const {
    accountID,
    licenseKey,
    applicationID,
    trustKey,
    allowedDomains,
  } = {
    ...DEFAULT_CONFIG,
    ...config
  };

  if (!accountID || !licenseKey || !applicationID || !trustKey) {
    console.error("New Relic: Missing required config", {
      accountID,
      licenseKey,
      applicationID,
      trustKey,
    });
    return;
  }

  window.NREUM = {
    init: {
      distributed_tracing: {
        enabled: true,
        cors_use_newrelic_header: true,
        cors_use_tracecontext_headers: true,
        allowed_origins: allowedDomains,
      },
      privacy: {
        cookies_enabled: true,
      },
      session_replay: {
        enabled: true,
        block_selector: "",
        mask_text_selector: "*",
        sampling_rate: 10,
        error_sampling_rate: 100,
        mask_all_inputs: true,
        collect_fonts: true,
        inline_images: false,
        fix_stylesheets: true,
        preload: false,
        mask_input_options: {},
      },
    },
    loader_config: {
      accountID,
      trustKey,
      agentID: applicationID,
      licenseKey,
      applicationID,
    },
    info: {
      beacon: "bam.eu01.nr-data.net",
      errorBeacon: "bam.eu01.nr-data.net",
      licenseKey,
      applicationID,
      sa: 1,
    },
  };

  const nrScript = document.createElement("script");
  nrScript.src = "https://js-agent.newrelic.com/nr-loader-spa-1.310.1.min.js";
  nrScript.onload = () => console.log("New Relic Agent fully loaded");
  nrScript.onerror = (err) => console.error("New Relic script failed to load", err);

  document.head.appendChild(nrScript);

  window.__NR_LOADER_INITIALIZED__ = true;
  console.log("New Relic Browser Agent Injected Successfully");
}

if (typeof window !== "undefined") {
  window.initNewRelic = initNewRelic;
}